import { Button } from '@/components';
import H1 from '@/components/heading/H1';
import React from 'react';
import * as styles from './index.module.less';
import { PublicArrowRightTail } from 'notta-web-icon';
import { WEB_APP_JP_SIGN_UP_URL } from '@/constants';
import RatioMedia from '@/components/ratio-media';
// import HonorPart from '../honor-part';

const HeroBanner = () => {
  return (
    <div className={styles.banner_layout}>
      <div className={styles.banner_container}>
        {/* 标题文字以及图片的容器 */}
        <div className={styles.content_cover_container}>
          <div className={styles.banner_content}>
            <H1>
              自動的に
              <wbr />
              音声を文字起こし
            </H1>
            <div className={styles.hero_desc}>
              <p style={{ marginBottom: '0px' }}>
                Notta
                <wbr />は<wbr />
                高精度
                <wbr />の<wbr />
                音声認識
                <wbr />と<wbr />
                AI要約機能
                <wbr />を<wbr />
                使って、
                <wbr />
                1時間
                <wbr />の<wbr />
                音声
                <wbr />を<wbr />
                5分
                <wbr />で<wbr />
                文字起こし
                <wbr />
                し、
                <wbr />
                簡潔な
                <wbr />
                要約
                <wbr />を<wbr />
                作成する
                <wbr />
                こと
                <wbr />が<wbr />
                できます。
                <wbr />
                インタビュー、
                <wbr />
                対面会議
                <wbr />や<wbr />
                Web会議
                <wbr />で<wbr />
                生成される
                <wbr />
                多量
                <wbr />の<wbr />
                音声
                <wbr />や<wbr />
                テキストデータ
                <wbr />を<wbr />
                AI
                <wbr />が<wbr />
                処理し、
                <wbr />
                重要な
                <wbr />
                ポイント
                <wbr />を<wbr />
                抽出
                <wbr />
                します。
              </p>
              <p style={{ marginBottom: '0px' }}>
                情報過多時代
                <wbr />に<wbr />
                商談
                <wbr />の<wbr />
                振り返り、
                <wbr />
                議事録
                <wbr />の<wbr />
                作成
                <wbr />や<wbr />
                情報
                <wbr />の<wbr />
                共有
                <wbr />を<wbr />
                効率化
                <wbr />
                してみましょう。
              </p>
            </div>
            <div className={styles.meeting_tools}>
              <img
                src="https://a.storyblok.com/f/159374/986x94/6eb07bf608/transliteration-form.png"
                alt="リアルタイム・音声ファイル・Web会議文字起こし・画面録画"
              />
              <img
                src="https://a.storyblok.com/f/159374/876x83/c623a4a25d/transliteration-form-middle.png"
                alt="リアルタイム・音声ファイル・Web会議文字起こし・画面録画"
              />
            </div>
            <div className={styles.btn_link_container}>
              <a href={WEB_APP_JP_SIGN_UP_URL} data-gtm="home-page-banner-sign-up-btn">
                <Button gradual type="primary">
                  いますぐ無料で始める
                </Button>
              </a>
              <a href="/pricing" data-gtm="home-page-banner-pricing-btn">
                <Button type="link" className={styles.pricing_btn}>
                  無料・有料機能比較 <PublicArrowRightTail style={{ marginLeft: '4px' }} size={18} />
                </Button>
              </a>
            </div>
          </div>
          <div className={styles.banner_cover}>
            <RatioMedia
              media={{
                type: 'image',
                src: 'https://www.notta.ai/pictures/notta-speech-to-text.png',
                alt: '文字起こし サービス Notta',
                objectFit: 'contain',
              }}
              ratio={3 / 4}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroBanner;
